/*eslint-disable*/
import React, { useState, useEffect } from "react";
// react plugin used to create a form with multiple steps
import ReactWizard from "react-bootstrap-wizard";
import "react-bootstrap-wizard/dist/react-wizard.css";
import "bootstrap/dist/css/bootstrap.css";
import styles from "assets/jss/material-kit-react/views/loginPage.js";
import { makeStyles } from "@material-ui/core/styles";
import PublishStepper from "components/PublishStepper.js";
import { useLocation } from "react-router-dom";
function StaffPublishWizard() {
  const location = useLocation();
  const [data, setdata] = useState(location.state.item);
  // useEffect(() => {
  //   setdata(location.state.item);
  //   console.log("data", data);
   
  // }, [data]);

  return (
    <>
      <PublishStepper data={data} />
    </>
  );
}

export default StaffPublishWizard;
